import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind-aware class joiner (same helper as doWallet's lib/cn). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
